/**
 * The heading a briefing card gives a post: a title a marshal recognises from
 * the street, and a line saying where exactly and in which place.
 *
 * The posts sheet writes one micro-location per post, usually a landmark with
 * the exact spot in brackets — "N-GEN & Mercator (ob križišču, drop-off)" — so
 * the bracket becomes the sub-line and the landmark the title. The sector (the
 * sheet's macro location) closes the sub-line, because a title alone does not
 * say which village it is in.
 *
 * `briefingTitle` is the coordinator's override from Mesta, for the posts whose
 * micro-location does not read as a title. The whole micro-location then moves
 * to the sub-line, so nothing the sheet said is lost from the card.
 */
export function briefingPostHeading(input: {
  micro: string;
  sector: string;
  briefingTitle?: string;
}): { title: string; sub: string } {
  const micro = input.micro.trim();
  const sector = input.sector.trim();
  const override = input.briefingTitle?.trim() ?? '';
  const join = (parts: string[]) => parts.filter((p) => p.length > 0).join(' · ');

  if (override) return { title: override, sub: join([micro, sector]) };

  // Only a bracket that closes the string and follows some text: a micro-location
  // that is nothing but a bracket, or carries one mid-sentence, stays whole.
  const m = /^(.*\S)\s*\(([^()]+)\)$/.exec(micro);
  if (!m) return { title: capitalise(micro), sub: sector };
  return { title: capitalise(m[1]!), sub: join([m[2]!.trim(), sector]) };
}

function capitalise(s: string): string {
  return s.length > 0 ? s[0]!.toLocaleUpperCase('sl-SI') + s.slice(1) : s;
}
